// extracted by mini-css-extract-plugin
export var fileUpload = "_gd-1";
export var modalButton = "_gd-0";